module.exports = __webpack_public_path__ + "static/img/green-ipa2.344d975.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/green-ipa2.png
// module id = /CnD
// module chunks = 1